import { baseThemeValues } from 'constants/common';

import { appliedFilterPreviewTheme } from '../AppliedFilters/theme';

const baseIconProps = {
  borderRadius: '5px',
  borderWidth: '1px',
  boxShadow: 'palette.transparent',
  outlineColor: 'palette.transparent',
  outlineWidth: '0px',
};

export const filtersTheme = {
  actions: {
    borderColor: 'palette.tertiary.20',
    borderWidth: '1px',
  },
  appliedFilterPreview: appliedFilterPreviewTheme,
  operationButton: {
    base: {
      ...baseIconProps,
      bg: 'palette.surface.4',
      borderColor: 'palette.tertiary.20',
      text: 'palette.tertiary.80',
    },
    disabled: {
      ...baseIconProps,
      bg: 'palette.transparent',
      borderColor: 'palette.neutral.20',
      text: 'palette.neutral.20',
    },
    focus: {
      ...baseIconProps,
      bg: 'palette.surface.3',
      borderColor: 'palette.tertiary.10',
      text: 'palette.tertiary.90',
    },
    hover: {
      ...baseIconProps,
      bg: 'palette.surface.3',
      borderColor: 'palette.tertiary.10',
      text: 'palette.tertiary.90',
    },
    pressed: {
      ...baseIconProps,
      bg: 'palette.surface.2',
      borderColor: 'palette.tertiary.20',
      text: 'palette.tertiary.95',
    },
  },
  operationItem: {
    active: {
      bg: 'palette.transparent',
      text: 'palette.tertiary.95',
    },
    base: {
      bg: 'palette.transparent',
      text: 'palette.tertiary.70',
    },
    hover: {
      bg: 'palette.primary.40:0.1',
      text: 'palette.tertiary.80',
    },
    pressed: {
      bg: 'palette.primary.40:0.15',
      text: 'palette.tertiary.80',
    },
  },
  removePresetButton: {
    base: {
      bg: 'transparent',
      icon: 'palette.error.40',
    },
    hover: {
      bg: 'palette.neutral.95:0.1',
      icon: 'palette.error.30',
    },
    pressed: {
      bg: 'palette.neutral.95:0.15',
      icon: 'palette.error.20',
    },
  },
  resetPreset: {
    active: {
      bg: 'palette.success.60',
      icon: 'palette.surface.3',
    },
    base: {
      bg: 'palette.success.60',
      borderRadius: '30px',
      icon: 'palette.surface.3',
    },
    hover: {
      bg: 'palette.success.70',
      icon: 'palette.surface.3',
    },
  },
  saveMessage: 'palette.tertiary.95',
  searchInput: {
    borderColor: 'palette.tertiary.20:0.5',
    borderWidth: '1px',
  },
  sectionHeader: {
    active: {
      bg: 'palette.tertiary.10',
      text: 'palette.tertiary.95',
    },
    base: {
      bg: 'palette.transparent',
      borderColor: 'palette.tertiary.20:0.5',
      borderWidth: '1px',
      text: 'palette.tertiary.60',
    },
  },
  sectionItem: {
    borderColor: 'palette.tertiary.20',
    borderWidth: '1px',
    conflictHint: {
      bg: 'palette.error.60:0.1',
      borderColor: 'palette.error.60',
      borderRadius: '8px',
      borderWidth: '1px',
      fontFamily: baseThemeValues.inherit,
      fontSize: '12px',
      fontWeight: 400,
      icon: 'palette.error.60',
      text: 'palette.error.60',
    },
    label: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '13px',
      fontWeight: 400,
      text: 'palette.tertiary.60',
    },
    scope: {
      borderColor: 'palette.tertiary.20',
      borderRadius: '10px',
      borderWidth: '1px',
      removeButton: {
        borderRadius: '30px',
        icon: 'palette.surface.2',
      },
    },
  },
};
